import React from "react";

const AboutStory = () => {
  return (
    <section id="story" className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-start">
          <div className="lg:col-span-6">
            <h2 className="text-3xl font-semibold text-[color:var(--navy)]">
              Why we exist
            </h2>
            <p className="mt-5 text-[color:var(--muted)] leading-relaxed">
              Quality systems fail when they are treated as paperwork instead of operating systems.
              We build disciplined, repeatable methods that teams can actually run every day.
            </p>
            <p className="mt-4 text-[color:var(--muted)] leading-relaxed">
              Our work connects people and processes through structured problem-solving,
              clear standards, and coaching that drives sustained performance.
            </p>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface)] p-8">
              <div className="text-sm font-semibold text-[color:var(--brand)]">
                What we believe
              </div>
              <div className="mt-3 text-2xl font-semibold text-[color:var(--navy)]">
                Processes can’t work for you unless your people work with you.
              </div>
              <div className="mt-6 grid gap-3">
                <div className="flex items-center gap-2 text-sm text-[color:var(--navy)]/85">
                  <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
                  People-first adoption
                </div>
                <div className="flex items-center gap-2 text-sm text-[color:var(--navy)]/85">
                  <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
                  Discipline over hype
                </div>
                <div className="flex items-center gap-2 text-sm text-[color:var(--navy)]/85">
                  <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
                  Measurable outcomes
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStory;
